export default "__VITE_ASSET__bed751cc__"